import React from 'react';
import Header from '../../components/header';
import NotFoundBody from './body';
import Footer from '../../components/footer';

function NotFound(props) {
    document.title = `404 Not Found`;
    return (
        <div>
            <Header></Header>
            <NotFoundBody></NotFoundBody>
            <Footer></Footer>
        </div>
    );
}

export default NotFound;